export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./mascot.vue?vue&type=template&id=29d6b704"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/mascot.vue?vue&type=template&id=29d6b704
// module id = EwTx
// module chunks = 0